"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var ArticlePreviewList_vue_1 = __importDefault(require("../../article-preview/ArticlePreviewList.vue"));
var UserInterestEmpty_vue_1 = __importDefault(require("../UserInterestEmpty.vue"));
var article_preview_list_service_1 = require("../../article-preview/article-preview-list.service");
var ScrollElement_vue_1 = __importDefault(require("../../scroll-element/ScrollElement.vue"));
var UserInterestArticles = /** @class */ (function (_super) {
    __extends(UserInterestArticles, _super);
    function UserInterestArticles() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // This array can contain ArticlePreview from any list
        _this.articlePreviewsToUpdate = [];
        return _this;
    }
    UserInterestArticles.prototype.created = function () {
        this.articlePreviewsToUpdate = [];
    };
    UserInterestArticles.prototype.getJustAddedListService = function () {
        return (0, article_preview_list_service_1.registerServices)({
            api: {
                http: this.$http,
                fetchPageUrl: '/local/api/v2/articles/user-interest',
            }
        });
    };
    UserInterestArticles.prototype.updateLists = function (articlePreviews) {
        this.articlePreviewsToUpdate = articlePreviews;
    };
    UserInterestArticles.prototype.buildUrl = function (relativePath) {
        return this.$http.defaults.baseURL + relativePath;
    };
    UserInterestArticles = __decorate([
        (0, vue_property_decorator_1.Component)({
            components: {
                ArticlePreviewList: ArticlePreviewList_vue_1.default,
                UserInterestEmpty: UserInterestEmpty_vue_1.default,
                ScrollElement: ScrollElement_vue_1.default,
            }
        })
    ], UserInterestArticles);
    return UserInterestArticles;
}(vue_1.default));
exports.default = UserInterestArticles;
